// NPM/System Imports
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";

// Global Var Imports
import dimensions from "../styles/dimensions";
import colors from "../styles/colors";

// Component Imports
import Hero from "../components/about/Hero"
import DetailLeft from "../components/about/DetailLeft";
import DetailRight from "../components/about/DetailRight";
import Layout from "../components/Layout";
import CTACard from "../components/CTACard"

const Section = styled("section")`
    margin-bottom: 10em;
    display: flex;
    flex-direction: column;

    @media(max-width:${dimensions.maxwidthTablet}px) {
        margin-bottom: 4em;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`

const RenderBody = ({ about, meta }) => (
  <>
    <Helmet
        title={meta.title}
        titleTemplate={`%s | ${meta.title}`}
        meta={[
            {
                name: `description`,
                content: meta.description,
            },
            {
                property: `og:title`,
                content: meta.title,
            },
            {
                property: `og:description`,
                content: meta.description,
            },
            {
                property: `og:type`,
                content: `website`,
            },
            {
                name: `twitter:card`,
                content: `summary`,
            },
            {
                name: `twitter:creator`,
                content: meta.author,
            },
            {
                name: `twitter:title`,
                content: meta.title,
            },
            {
                name: `twitter:description`,
                content: meta.description,
            },
        ].concat(meta)}
    />

    <Hero
      headline={about.hero_title}
      copy={about.hero_subtitle}
      image={about.hero_image}
    />

    <DetailLeft
        headline={about.detail_1_title}
        copy={about.about_details}
        image={about.about_image_1}
    />

    <DetailRight
        headline={about.detail_2_title}
        copy={about.about_details_2}
        image={about.about_image_2}
    />

    <CTACard 
      title={about.cta_title}
      copy={about.cta_copy}
      image={about.cta_image}
      link_text={about.cta_link_text}
      link_target={about.cta_link_target.url}
    />        
      
  </>
);

export default ({ data }) => {
    //Required check for no data being returned
    const doc = data.prismic.allAbouts.edges.slice(0, 1).pop();
    const meta = data.site.siteMetadata;

    if (!doc) return null;

    return (
        <Layout>
            <RenderBody about={doc.node} meta={meta}/>
        </Layout>
    )
}

RenderBody.propTypes = {
    about: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
};

export const query = graphql`
{
  prismic {
    allAbouts {
      edges {
        node {
          hero_image
          hero_title
          hero_subtitle
          detail_1_title
          about_details
          about_image_1
          detail_2_title
          about_details_2
          about_image_2
          cta_title
          cta_copy
          cta_image
          cta_link_text
          cta_link_target {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          meta_description
          meta_title
          og_title
          og_description
          og_image
        }
      }
    }
  }
  site {
      siteMetadata {
          title
          description
          author
      }
  }
}
`